<template>
    <div>
        <table class="table">
            <thead>
                <tr>
                    <th class="mw-70">ID</th>
                    <th>Task Name</th>
                    <th>Task Type</th>
                    <th>Time</th>
                    <th>Started At</th>
                    <th>PID</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(task, index) in taskList" :key="task.id">
                    <td>{{ task.id }}</td>
                    <td>{{ task.classname }}</td>
                    <td>{{ task.type }}</td>
                    <td>{{ task.time }}</td>
                    <td>{{ dateFormat(task.timestarted) }}</td>
                    <td>{{ task.pid }}</td>
                </tr>

                <tr v-if="taskList.length === 0">
                    <td class="table-empty" colspan="6">No tasks!</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import moment from "moment";

export default {
    props: {
        tasksList: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            connectionId: this.connection,
            taskList: {},
            loading: false
        }
    },

    created() {
        this.renderList();
    },

    methods: {
        renderList() {
            this.taskList = this.tasksList.length > 0
                ? JSON.parse(this.tasksList)
                : {};
        },
        dateFormat(date) {
            return moment.unix(date).utc().format('DD MMM YYYY HH:mm:ss');
        }
    }
}
</script>
